import React from 'react';
import {withCookies} from 'react-cookie';
import Sentry from '../lib/Sentry';
import FullStory from '../util/FullStory';
import GeneralError from './GeneralError';

const TRACKING_COOKIE_NAME = 'tid';
export class ErrorBoundary extends React.Component {
  state = {
    appError: false,
  };

  componentDidMount = () => {
    this.setUserContext();
  };

  componentDidUpdate = () => {
    this.setUserContext();
  };

  componentDidCatch = (error, errorInfo) => {
    this.setState({appError: true});
    const sentryEventId = Sentry.captureException(error, {errorInfo, calledFrom: 'ErrorBoundary'});
    FullStory.log(`Sentry event id: ${sentryEventId}`);
  };

  setUserContext = () => {
    const {cookies} = this.props;
    const trackingId = cookies.get(TRACKING_COOKIE_NAME);
    if (trackingId) {
      Sentry.setUser(trackingId);
    }
  };

  render() {
    const {children} = this.props;
    const {appError} = this.state;

    return appError ? <GeneralError /> : {...children};
  }
}

export default withCookies(ErrorBoundary);
